import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterList } from '../router';

@Component({
  selector: 'app-side',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ul mwc-menu [mwcMode]="'inline'" class="aside-container menu-site" [mwcInlineIndent]="40" [class.mwc-menu-rtl]="direction === 'rtl'">
      <ng-container *ngIf="page === 'docs'">
        <li *ngFor="let intro of routerList.intro" mwc-menu-item mwcMatchRouter [hidden]="intro.language !== language || intro.hidden">
          <a routerLink="{{ intro.path }}">{{ intro.label }}</a>
        </li>
      </ng-container>

      <ng-container *ngIf="page === 'components'">
        <li mwc-menu-item mwcMatchRouter>
          <a routerLink="components/overview/{{ language }}">
            <span *ngIf="language === 'en'">Components Overview</span>
            <span *ngIf="language === 'zh'">组件总览</span>
          </a>
        </li>

        <li mwc-menu-group *ngFor="let group of routerList.components" [hidden]="group.language !== language" [mwcTitle]="group.name">
          <ul>
            <ng-container>
              <li mwc-menu-item mwcMatchRouter *ngFor="let component of group.children">
                <a routerLink="{{ component.path }}">
                  <span>{{ component.label }}</span>
                  <span class="chinese">{{ component.zh }}</span>
                </a>
              </li>
            </ng-container>
          </ul>
        </li>
      </ng-container>

      <ng-container *ngIf="page === 'experimental'">
        <li
          mwc-menu-group
          *ngFor="let group of routerList.components"
          [hidden]="group.language !== language || group.experimentalChildren.length === 0"
          [mwcTitle]="group.name"
        >
          <ul>
            <ng-container>
              <li mwc-menu-item mwcMatchRouter *ngFor="let component of group.experimentalChildren">
                <a routerLink="{{ component.path }}">
                  <span>{{ component.label }}</span>
                  <span class="chinese">{{ component.zh }}</span>
                </a>
              </li>
            </ng-container>
          </ul>
        </li>
      </ng-container>
    </ul>
  `
})
export class SideComponent {
  @Input() direction: 'ltr' | 'rtl' = 'ltr';
  @Input() page: 'docs' | 'components' | 'experimental' | string = 'docs';
  @Input() routerList: RouterList = {} as RouterList;
  @Input() language: 'zh' | 'en' = 'en';
}
